import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { heroData } from '../data/mock';

const Hero = () => {
  const scrollToVolunteer = () => {
    const element = document.getElementById('volunteer');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Buddhist Flag Color Accents */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-yellow-50 to-orange-50"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
      <div className="absolute top-40 right-10 w-72 h-72 bg-yellow-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
      <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-4000"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-blue-200 shadow-sm">
              <Sparkles className="w-4 h-4 text-blue-600" />
              <span className="text-sm font-medium text-gray-700">Ambedkarite Buddhist Organization</span>
            </div>

            {/* Organization Name */}
            <div className="space-y-2">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                MASS MOVEMENT FOR TRANSFORMATION
              </h2>
              <p className="text-lg text-blue-600 font-semibold italic">
                A Movement for Payback to Society
              </p>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
              <span className="bg-gradient-to-r from-blue-600 via-yellow-600 to-orange-600 bg-clip-text text-transparent">
                {heroData.title}
              </span>
            </h1>

            <p className="text-2xl md:text-3xl font-semibold text-gray-800">
              {heroData.subtitle}
            </p>

            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
              {heroData.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToVolunteer}
                className="group px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2"
              >
                Join Our Mission
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <button 
                onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold border-2 border-blue-600 hover:bg-blue-50 transition-colors duration-300"
              >
                Learn More
              </button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img 
                src={heroData.image} 
                alt="Buddha Meditation" 
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl border-l-4 border-orange-500">
              <p className="text-sm text-gray-600 mb-1">Our Vision</p>
              <p className="text-xl font-bold text-gray-800">Enlightened India</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
